<div class="shipment-details">
  <div class="shipment-details__header">
    @if (shipmentData && !isArchived) {
      <span
        matTooltip="{{ isBeingWatched ? 'Remove from watch list' : 'Add to watch list' }}"
        class="material-symbols-outlined shipment-details__header--watch"
        [ngClass]="{ 'shipment-details__header--unwatched': !isBeingWatched }"
        (click)="toggleWatch()"
        >star</span
      >
    }
    <div class="shipment-details__header--shipment-no">{{ shipmentData?.shipmentNo }}</div>
    @if (shipmentData) {
      <span
        class="material-symbols-outlined shipment-details__header--share"
        matTooltip="Copy public tracking link to clipboard"
        matTooltipPosition="above"
        (click)="copyTrackingLink()"
        >share</span
      >
    }
    <a (click)="onClose()" class="material-symbols-outlined shipment-details__header--close">close</a>
  </div>
  <mat-tab-group class="shipment-details__tab-group" (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Details">
      <ng-template mat-tab-label><span class="material-symbols-outlined">info</span>DETAILS</ng-template>
      <app-details [shipment]="shipmentData"></app-details>
      <app-containers [shipment]="shipmentData" [isArchived]="isArchived"></app-containers>
      <app-purchase-order-list [orders]="shipmentData?.purchaseOrders"></app-purchase-order-list>
      <app-routing [item]="shipmentData"></app-routing>
      <app-scan-buttons
        [shipment]="shipmentData"
        [openedFrom]="openedFrom"
        [isArchived]="isArchived"></app-scan-buttons>
    </mat-tab>
    <mat-tab label="Documents">
      <ng-template mat-tab-label><span class="material-symbols-outlined">description</span>DOCUMENTS</ng-template>
      @if (!isArchived) {
        <app-documents [shipmentNumber]="shipmentData?.shipmentNo" [isArchived]="isArchived"></app-documents>
      }
      <app-document-list [shipmentNumber]="shipmentData?.shipmentNo" [isArchived]="isArchived"></app-document-list>
    </mat-tab>
    @if (!isArchived) {
      <mat-tab label="Custom Fields">
        <ng-template mat-tab-label><span class="material-symbols-outlined">tune</span>CUSTOM FIELDS</ng-template>
        <app-custom-fields [item]="shipmentData"></app-custom-fields>
      </mat-tab>
    }
    <mat-tab label="All Events">
      <ng-template mat-tab-label><span class="material-symbols-outlined">flag_check</span>ALL EVENTS</ng-template>
      <app-last-event [item]="shipmentData"></app-last-event>
      <app-all-events [item]="shipmentData"></app-all-events>
    </mat-tab>
  </mat-tab-group>
</div>
